"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAttachment = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconAttachment = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_929_10110)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1472 4.00519C17.0732 2.93125 15.332 2.93125 14.2581 4.0052L5.24248 13.0208C3.48512 14.7782 3.48512 17.6274 5.24248 19.3848C6.99984 21.1421 9.84908 21.1421 11.6064 19.3848L20.6221 10.3692C20.9149 10.0763 21.3898 10.0763 21.6827 10.3692C21.9756 10.662 21.9756 11.1369 21.6827 11.4298L12.6671 20.4454C10.324 22.7886 6.52497 22.7886 4.18182 20.4454C1.83868 18.1023 1.83868 14.3033 4.18182 11.9601L13.1974 2.94454C14.8572 1.28481 17.5481 1.28481 19.2078 2.94453C20.8676 4.60426 20.8676 7.29521 19.2078 8.95494L10.5458 17.617C9.56947 18.5933 7.98656 18.5933 7.01025 17.617C6.03394 16.6407 6.03394 15.0578 7.01025 14.0815L14.6116 6.48007C14.9045 6.18718 15.3794 6.18718 15.6723 6.48007C15.9652 6.77296 15.9652 7.24784 15.6723 7.54073L8.07091 15.1421C7.68038 15.5327 7.68038 16.1658 8.07091 16.5563C8.46143 16.9469 9.0946 16.9469 9.48512 16.5563L18.1472 7.89428C19.2211 6.82034 19.2211 5.07914 18.1472 4.00519Z",
    fill: color
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_929_10110"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: size,
    height: size,
    fill: "white"
  }))))));
};
exports.IconAttachment = IconAttachment;
//# sourceMappingURL=IconAttachment.js.map